import React from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Divider
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {HugeiconsIcon} from "@hugeicons/react";
import {CheckListIcon, CloudUploadIcon, FloppyDiskIcon, Logout01Icon, Menu01Icon} from "@hugeicons/core-free-icons";
import {Link} from "react-router-dom";
import {signOut} from "firebase/auth";
import {auth} from "../../../config/firebase";
import {ProjectRoles} from "../../../context/AppContext";

export const HeaderDrawer = ({open, handleClose, project, userRole, loading, onCheck, onPublish, onDeploy}) => {

  const logoutHandle = async () => {
    try {
      await signOut(auth);
      handleClose();
    } catch (err) {
      console.error(err);
    }
  }

  const disabled = !project || loading;

  return (
    <Drawer
      anchor={"right"}
      open={open}
      onClose={handleClose}
      sx={{
        height: "100vh",
        width: '100%',
        flex: 1,
        display: {xs: "inherit", md: "none"},

      }}
      PaperProps={{
        sx: {
          maxWidth: "360px",
          width: "100% !important",
        },
      }}
    >
      <Stack direction={"column"} gap={1} sx={{
        height: "100vh",
        maxWidth: "360px",
        width: "100% !important",
        bgcolor: "#FFF"
      }}>
        <Box sx={{p: 2, bgcolor: "#FFF"}}>
          <IconButton onClick={handleClose}>
            <HugeiconsIcon icon={Menu01Icon}/>
          </IconButton>
        </Box>
        <Box sx={{flex: 1, maxHeight: "100%", overflowY: 'auto'}}>
          <List>

            {userRole !== ProjectRoles.AGENT && (
              <>
                <ListItemButton disabled={disabled} onClick={() => onCheck?.()}>
                  <ListItemIcon>
                    <HugeiconsIcon icon={CheckListIcon}/>
                  </ListItemIcon>
                  <ListItemText primary={"Validate"}/>
                </ListItemButton>
                <ListItemButton disabled={disabled} onClick={() => { handleClose(); onPublish?.(); }}>
                  <ListItemIcon>
                    <HugeiconsIcon icon={FloppyDiskIcon}/>
                  </ListItemIcon>
                  <ListItemText primary={"Save"}/>
                </ListItemButton>
                {project?.settings?.deploymentProject && (
                  <ListItemButton disabled={disabled} onClick={() => { handleClose(); onDeploy?.(); }}>
                    <ListItemIcon>
                      <HugeiconsIcon icon={CloudUploadIcon}/>
                    </ListItemIcon>
                    <ListItemText primary={"Deploy"}/>
                  </ListItemButton>
                )}
                <Divider sx={{my: 1}}/>
              </>
            )}

            <ListItemButton onClick={handleClose} component={Link} to={"/projects"}>
              <ListItemText>
                <Typography variant={"subtitle2"} fontWeight={"bold"}>Projects</Typography>
              </ListItemText>
            </ListItemButton>
            <ListItemButton onClick={logoutHandle}>
              <ListItemIcon>
                <HugeiconsIcon icon={Logout01Icon}/>
              </ListItemIcon>
              <ListItemText primary={"Logout"}/>
            </ListItemButton>

          </List>
        </Box>
      </Stack>
    </Drawer>
  )
}
